import { GridColDef } from '@mui/x-data-grid-premium';
import { useMemo } from 'react';
import { tableSettingsProps, useTableSettings } from 'src/core/tables/useTableSettings';
import tableHelper from 'src/core/tables/tableHelper';
import { usePurchasingShippingMethods } from 'src/pages/settings/settingsRequests';

export const usePurchasingShippingMethodsTable = (): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const { rows, status, loading } = usePurchasingShippingMethods();
  const columns: GridColDef[] = useMemo(() => [
    { field: 'Id', headerName: 'Id', valueGetter: tableHelper.getFieldKeyOrValue },
    { field: 'Name', headerName: 'Name', flex: 1 },
    { field: 'PurchaseOrderTypeAllowed', headerName: 'Purchase Order Type Allowed' },
    { field: 'ExternalShippingMethodId', headerName: 'External Shipping Method Id' },
  ], []);
  const tableSettings = useTableSettings({ tableName: 'PurchasingShippingMethodsTable', idPath: ['Id'], columns, rows, status });
  tableSettings.loading = loading;
  return [columns, tableSettings];
};
